<template>
  <HelloWorld v-if="false" msg="Welcome to Your Vue.js App"/>
  <DebugDesigns v-if="false"></DebugDesigns>
  <DesignSetExample v-if="false"></DesignSetExample>
  <FullGame v-if="true"></FullGame>
</template>

<script>
import config from "@/assets/config.json";
import designSets from '@/assets/designSets.json'
import HelloWorld from '@/components/HelloWorld.vue'
import DebugDesigns from '@/DebugDesigns.vue'
import DesignSetExample from '@/DesignSetExample.vue'
import FullGame from '@/FullGame.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    DebugDesigns,
    DesignSetExample,
    FullGame
  },
  data() {
    return {
      cardColors: designSets[config.activeDesignId].cardColors,
      symbolColors: designSets[config.activeDesignId].symbols.colors
      /*
      debugMode: config.debugMode,
      cardColor: designSets[config.activeDesignId].cardColor,
      hoverColor: designSets[config.activeDesignId].hoverColor,
      activeColor: designSets[config.activeDesignId].activeColor,
      validColor: designSets[config.activeDesignId].validColor,
      invalidColor: designSets[config.activeDesignId].invalidColor
      */
    }
  }
}
</script>


